export const GDA_ELIGIBLE = 'GDAEligible';
export const GDA_MEMBER = 'GDAMember';
export const GDA_COOKIE_NAME = 'GDA';
export const CMT_COOKIE_NAME = 'CMType';
export const GOLD_CARD = 'GoldCard';

export const GOLDCARD_NAME = 'GoldCard';
export const DELTA_RESERVE_NAME = 'DeltaReserve';
export const DELTA_PLATINUM_NAME = 'DeltaPlatinum';
export const AMEX_PLATINUM_NAME = 'PlatinumCard';

export const RESYVALUE_CARD_MEMBER = 'Amex Card Member';
// Page Names
export const AMEX_GDA_PAGE = 'Amex GDA';
export const AMEX_RESY_CREDIT = 'Resy Credit';
export const AMEX_RESY_VALUE = 'Resy Value';
export const AMEX_GDA_DIRECTORY_PAGE = 'Amex GDA Directory';
export const AMEX_PLATINUM_NIGHTS_PAGE = 'Amex Platinum Nights';
